module.exports = __webpack_public_path__ + "static/noticias-13--3b042f61b47ffa99f875f0e664b48d77.png";